import { Helmet } from 'react-helmet-async'

export default function Seo({ title, description, keywords }) {
  const brand = 'Saatbahane'
  const pageTitle = title ? `${title} | ${brand}` : `${brand} - Premium Luxury Watches Istanbul`
  const pageDescription = description || "Istanbul's premier destination for luxury timepieces. Buy, sell, and trade Rolex, Patek Philippe, Audemars Piguet with 100% authenticity guarantee."
  const pageKeywords = keywords || 'luxury watches, rolex istanbul, patek philippe, audemars piguet, second hand watches turkey, saatbahane'

  return (
    <Helmet>
      <html lang={document.documentElement.lang || 'tr'} />
      <title>{pageTitle}</title>
      <meta name="description" content={pageDescription} />
      <meta name="keywords" content={pageKeywords} />
      <meta property="og:title" content={pageTitle} />
      <meta property="og:description" content={pageDescription} />
      <meta property="og:type" content="website" />
      <meta property="og:url" content="https://saatbahane.com" />
      <meta property="og:image" content="https://saatbahane.com/logo.png" />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={pageTitle} />
      <meta name="twitter:description" content={pageDescription} />
      <link rel="canonical" href={`https://saatbahane.com${window.location.pathname}`} />
    </Helmet>
  )
}

